import fetchStream from "./fetchStream";
import { streamEvents } from "./streamEvents";
import { JsonListParser } from "./jsonList";

// Something went wrong on the server or with the model; worth retrying
export class StreamError extends Error {}

export const RETRY_LIMIT = 3;
export const retryDelay = (retries) => 500 * retries + 500;

export function isRetryable(error) {
  return error instanceof StreamError || error instanceof TypeError;
}

// Streams a JSON list from the API, calling onItem as each item completes.
// Resolves to { status, count }. Aborting the signal rejects with an AbortError.
export async function streamList(endpoint, body, { signal, onItem }) {
  const { reader, status } = await fetchStream(
    endpoint,
    body,
    true,
    true,
    true,
    signal
  );
  if (!reader) {
    return { status, count: 0 };
  }
  const parser = new JsonListParser();
  let count = 0;
  for await (const event of streamEvents(reader)) {
    if (event.error) {
      throw new StreamError(event.error);
    }
    const text = typeof event.cached === "string" ? event.cached : event.text;
    if (typeof text !== "string") continue;
    for (const item of parser.push(text)) {
      count += 1;
      onItem(item);
    }
  }
  return { status, count };
}
